export enum GaEventCategory {
    Matching = "Matching",
    Behaviour = "Behaviour",
    Basket = "Basket",
    Errors = "Errors",
    Debug = "Debug"
}